import React from 'react'
import { Link } from 'react-router-dom'
import { Paintbrush, Phone, Mail, MapPin, ShieldCheck } from 'lucide-react'

export default function Footer() {
  const currentYear = new Date().getFullYear()

  return (
    <>
      {/* Trust & Badges banner */}
      <div className="bg-sky-600 py-6 text-white">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 text-center sm:text-left">
            <ShieldCheck className="h-8 w-8 text-white shrink-0" />
            <div>
              <h4 className="font-semibold text-white text-sm">Garanti for veludført arbejde</h4>
              <p className="text-xs text-sky-100">Din tryghed for professionelt håndværk og høj kvalitet.</p>
            </div>
          </div>
        </div>
      </div>

      <footer 
        className="relative bg-cover bg-center text-slate-600 border-t border-slate-200"
        style={{ backgroundImage: "url('https://assets.auxodev.dk/assets/8102f19c-aab0-44cc-aa15-a120b6503274/03d51039-f7b5-4aa5-9c5f-ed5869a95e92.jpg')" }}
      >
      {/* Semi-transparent overlay to ensure readability */}
      <div className="absolute inset-0 bg-[#f1f1f1]/95 backdrop-blur-[1px]" />

      <div className="relative z-10">
        {/* Main Footer Content */}
        <div className="mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:px-8 lg:py-16">
          <div className="grid grid-cols-1 gap-10 sm:grid-cols-3">
            <div className="space-y-4">
              <Link to="/" className="flex items-center gap-2.5 group">
                <Paintbrush className="h-7 w-7 text-sky-600 fill-sky-100 transition-transform group-hover:rotate-12" />
                <div>
                  <span className="text-2xl md:text-3xl font-bold tracking-tight text-slate-900 transition-colors group-hover:text-black">
                    Probyg <span className="text-slate-900">Maler</span>
                  </span>
                </div>
              </Link>
              
              <ul className="space-y-3 text-sm pt-2">
                <li className="flex items-start gap-2.5">
                  <MapPin className="h-5 w-5 text-slate-900 shrink-0 mt-0.5" />
                  <span className="text-slate-600">
                    Njalsgade 21F 2.,<br />
                    2300 København S
                  </span>
                </li>
                <li className="flex items-center gap-2.5">
                  <Phone className="h-5 w-5 text-slate-900 shrink-0" />
                  <a href="tel:+4592900091" className="text-slate-600 hover:text-slate-900 transition-colors">
                    +45 92 90 00 91
                  </a>
                </li>
                <li className="flex items-center gap-2.5">
                  <Mail className="h-5 w-5 text-slate-900 shrink-0" />
                  <a href="mailto:info@probyg.tech" className="text-slate-600 hover:text-slate-900 transition-colors">
                    info@probyg.tech
                  </a>
                </li>
              </ul>

              <hr className="border-slate-200/60" />

              <div className="text-sm text-slate-600 pt-1">
                <p>Probyg Maler ApS · CVR-nr: 46347870</p>
              </div>
            </div>

            {/* Quick Links */}
            <div>
              <h3 className="text-sm font-semibold uppercase tracking-wider text-slate-900">Hurtige Links</h3>
              <ul className="mt-4 space-y-2.5 text-sm">
                <li>
                  <Link to="/" className="hover:text-slate-900 transition-colors">Forside</Link>
                </li>
                <li>
                  <Link to="/galleri" className="hover:text-slate-900 transition-colors">Galleri & Referencer</Link>
                </li>
                <li>
                  <Link to="/prisestimater" className="hover:text-slate-900 transition-colors">Prisestimater</Link>
                </li>
                <li>
                  <Link to="/om-os" className="hover:text-slate-900 transition-colors">Om Os</Link>
                </li>
                <li>
                  <Link to="/kontakt" className="hover:text-slate-900 transition-colors">Kontakt & Tilbud</Link>
                </li>
                <li>
                  <Link to="/privatlivspolitik" className="hover:text-slate-900 transition-colors">Privatlivspolitik</Link>
                </li>
              </ul>
            </div>

            {/* Services List */}
            <div>
              <h3 className="text-sm font-semibold uppercase tracking-wider text-slate-900">Vores Ydelser</h3>
              <ul className="mt-4 space-y-2.5 text-sm">
                <li>
                  <Link to="/ydelser/indendoers-maling" className="hover:text-slate-900 transition-colors">Indendørs Maling</Link>
                </li>
                <li>
                  <Link to="/ydelser/udendoers-maling" className="hover:text-slate-900 transition-colors">Udendørs Maling</Link>
                </li>
                <li>
                  <Link to="/ydelser/tapetsering-filt" className="hover:text-slate-900 transition-colors">Tapetsering & Filt</Link>
                </li>
                <li>
                  <Link to="/ydelser/erhvervsmaling" className="hover:text-slate-900 transition-colors">Erhvervsmaling</Link>
                </li>
              </ul>
            </div>
          </div>

          {/* Bottom Bar */}
          <div className="mt-12 border-t border-slate-200 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-slate-500">
            <p>Udviklet med fokus på kvalitet og brugervenlighed. Alle rettigheder forbeholdes Probyg Maler.</p>
            <div className="flex gap-4">
              <Link to="/privatlivspolitik" className="hover:text-slate-900 transition-colors underline">Privatlivspolitik</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
    </>
  )
}
